// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ht-0";